export const codes = {
  invalidCredentials: 401
} as const;
